var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1379_88342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5249 9.33984C15.2145 9.33984 14.9629 9.59145 14.9629 9.9019V20.5248C14.9629 20.8351 15.2145 21.0869 15.5249 21.0869C15.8354 21.0869 16.087 20.8351 16.087 20.5248V9.9019C16.087 9.59145 15.8354 9.33984 15.5249 9.33984Z",
    fill: "#146C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89214 9.33984C8.58169 9.33984 8.33008 9.59145 8.33008 9.9019V20.5248C8.33008 20.8351 8.58169 21.0869 8.89214 21.0869C9.20259 21.0869 9.4542 20.8351 9.4542 20.5248V9.9019C9.4542 9.59145 9.20259 9.33984 8.89214 9.33984Z",
    fill: "#146C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05923 7.78956V21.6375C4.05923 22.456 4.35936 23.2247 4.88366 23.7762C5.40554 24.3293 6.13182 24.6432 6.89192 24.6445H17.5263C18.2866 24.6432 19.0129 24.3293 19.5345 23.7762C20.0588 23.2247 20.3589 22.456 20.3589 21.6375V7.78956C21.4012 7.51292 22.0765 6.50605 21.9371 5.4366C21.7975 4.36737 20.8865 3.56753 19.8081 3.56731H16.9304V2.86474C16.9337 2.27392 16.7001 1.70659 16.2818 1.28922C15.8636 0.872063 15.2954 0.639775 14.7045 0.644605H9.71363C9.12281 0.639775 8.55461 0.872063 8.13635 1.28922C7.7181 1.70659 7.4845 2.27392 7.48779 2.86474V3.56731H4.61009C3.53164 3.56753 2.62071 4.36737 2.48107 5.4366C2.34166 6.50605 3.01701 7.51292 4.05923 7.78956ZM17.5263 23.5204H6.89192C5.93093 23.5204 5.18335 22.6949 5.18335 21.6375V7.83896H19.2348V21.6375C19.2348 22.6949 18.4872 23.5204 17.5263 23.5204ZM8.61191 2.86474C8.60818 2.57207 8.72322 2.29038 8.93092 2.08378C9.1384 1.87718 9.42075 1.76367 9.71363 1.76872H14.7045C14.9974 1.76367 15.2798 1.87718 15.4873 2.08378C15.695 2.29017 15.81 2.57207 15.8063 2.86474V3.56731H8.61191V2.86474ZM4.61009 4.69143H19.8081C20.3668 4.69143 20.8198 5.14437 20.8198 5.70314C20.8198 6.2619 20.3668 6.71484 19.8081 6.71484H4.61009C4.05133 6.71484 3.59839 6.2619 3.59839 5.70314C3.59839 5.14437 4.05133 4.69143 4.61009 4.69143Z",
    fill: "#146C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2085 9.33984C11.8981 9.33984 11.6465 9.59145 11.6465 9.9019V20.5248C11.6465 20.8351 11.8981 21.0869 12.2085 21.0869C12.519 21.0869 12.7706 20.8351 12.7706 20.5248V9.9019C12.7706 9.59145 12.519 9.33984 12.2085 9.33984Z",
    fill: "#146C94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1379_88342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.214844 0.644531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.aaf535c3a8eea8fb54925be8cb27e022.svg";
export { ForwardRef as ReactComponent };